import { NgModule } from '@angular/core';
import { HisTableConfigComponent } from './component/config/his-table-config.component';
import { HisTableToolbarComponent } from './component/toolbar/his-table-toolbar.component';
import { HisColumnStateDirective } from './directive/his-column-state.directive';
import { HisReorderableColumnDirective } from './directive/his-reorderable-column.directive';
import { HisTableContextDirective } from './directive/his-table-context.directive';
import { HisTableMetaDirective } from './directive/his-table-meta.directive';

@NgModule( {
    imports: [
        // Components
        HisTableConfigComponent,
        HisTableToolbarComponent,

        // Directives
        HisColumnStateDirective,
        HisTableContextDirective,
        HisTableMetaDirective,
        HisReorderableColumnDirective,
    ],
    declarations: [],
    exports: [
        // Components
        HisTableConfigComponent,
        HisTableToolbarComponent,

        // Directives
        HisColumnStateDirective,
        HisTableContextDirective,
        HisTableMetaDirective,
        HisReorderableColumnDirective,
    ]
})
export class HisTableSharedModule { }